import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { CurrencyComponent } from '../currency/currency.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-currency-list',
  templateUrl: './currency-list.component.html',
  styleUrls: ['./currency-list.component.css']
})
export class CurrencyListComponent implements OnInit {

  public menu_item_id = '47';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['currency_name', 'currency_name_en', 'currency_code', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<CurrencyComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'currency', 'currency_name': '', 'currency_name_en': '', 'currency_code': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {

    let condition = "";

    if (this.model['currency_name'] != '')
      condition = " (`currency_name` LIKE '%" + this.model['currency_name'] +
        "%' OR `currency_name_en` LIKE '%" + this.model['currency_name'] + "%') AND ";
    let query = "SELECT * FROM `currency` WHERE" + condition + " `status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newCurrency() {
    this.addDialogRef = this.dialog.open(CurrencyComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  editCurrency(row) {
    let isbase = 0;
    if (row.is_base == '1')
      isbase = 1;
    let dialog_data = {
      'table_name': 'currency', 'currency_id': row.currency_id,
      'currency_name': row.currency_name,
      'currency_name_en': row.currency_name_en,
      'currency_code': row.currency_code,
      'is_base': isbase,
      'multiply': row.multiply,
      'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(CurrencyComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delCurrency(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'currency_id': row.currency_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
